export default () => ({
  contentContainer: {},
  dialogPaper: { width: '100%' },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  title: { flex: 1 },
  dialogContent: {
    padding: '0 1em',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
});
